var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLivieAiChatbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1373_13177)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#3B61E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54137 10.2122C6.54245 10.0006 6.59546 9.79248 6.69574 9.60614C6.79599 9.41986 6.94049 9.26097 7.11649 9.14352L11.9004 5.95109C12.3409 5.65711 12.9077 5.63027 13.3741 5.88127L18.7374 8.7679C19.2038 9.01891 19.4935 9.50677 19.4909 10.0364L19.4615 15.7878C19.4604 15.9994 19.4075 16.2075 19.3072 16.3938C19.2069 16.5802 19.0624 16.739 18.8864 16.8565L15.0922 19.0258C14.9625 19.1124 14.9037 19.2729 14.9469 19.4228L14.9469 20.5944C15.0347 20.8991 14.7124 21.1592 14.4332 21.0089L7.2655 17.2321C6.79913 16.9811 6.50934 16.4932 6.51207 15.9637L6.54137 10.2122ZM13.6061 17.9104C13.3859 18.0573 13.1025 18.0707 12.8694 17.9453L8.85715 15.5348C8.62397 15.4093 8.47906 15.1654 8.48039 14.9006L8.49902 11.251C8.50019 11.0129 8.61961 10.791 8.81765 10.6589L12.3968 8.08964C12.617 7.94267 12.9004 7.92922 13.1336 8.05472L17.1458 10.4651C17.3789 10.5906 17.5238 10.8346 17.5225 11.0994L17.5039 14.749C17.5027 14.9871 17.3833 15.209 17.1853 15.3411L13.6061 17.9104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.87305,
    y: 11.8896,
    width: 1.38402,
    height: 2.42216,
    rx: 0.692008,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.2949,
    y: 11.1972,
    width: 1.38402,
    height: 3.80625,
    rx: 0.692008,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7188,
    y: 11.8896,
    width: 1.38402,
    height: 2.42216,
    rx: 0.692008,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1373_13177",
    x: -9.28572,
    y: -9.28572,
    width: 44.5714,
    height: 44.5714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1373_13177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1373_13177",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivieAiChatbot);
export default __webpack_public_path__ + "static/media/livie-ai--chatbot.f8883b6a777af323789db078288fad69.svg";
export { ForwardRef as ReactComponent };